let getter = null;
export function setAccessTokenGetter(fn) { getter = typeof fn === 'function' ? fn : null; }
export async function getAccessToken() { if (!getter) return null; try { return (await getter()) || null; } catch { return null; } }
